export const getStyles = (theme?:any) => ({
  container: { height: '70vh', width: '100%' },
  popupContentBox: {
    padding: '20px',
    width: '320px',
  },
	popupContent: {
    padding: '20px',
    flexWrap: 'nowrap', overflowX: 'auto',
		marginBottom: '10px',
    overflowY: 'hidden'
  },
	title: { fontSize: '12px', color: 'gray' },
  newRowTitle: { fontSize: '12px', color: 'gray' },
  calendarWidth:{ border: '1px solid #c9c9c9', borderRadius: '3px', padding: '6px',width:'100%' },
  calenderContainer: { border: '1px solid #c9c9c9', borderRadius: '3px', padding: '6px' },
  input: { border: '1px solid #c9c9c9', borderRadius: '3px', padding: '0 6px', width: '100%' },
  calenderInputContainer: { display: 'flex', alignItems: 'center', border: 'none', width: '100%' },
  calenderInput: { fontFamily: '16px', border: 'none', width: '85%', outline: 'none' },
  select: { height: '30px', width: '100%' },
  textarea: { color: theme?.palette?.textBlack?.main, border: '1px solid #c9c9c9', borderRadius: '3px', padding: '5px', outline: 'none', width: '100%',maxHeight:'110px',overflow:'visible'},
  buttonContainer: { width: '100%', display: 'flex', alignItem: 'center', justifyContent: 'center' },
	btnContainer: { width: '100%', display: 'flex', alignItem: 'end', justifyContent: 'end' },
  newRowButton: { margin: '5px' },
  alert: { width: '100%' },
  progress: { width: '16px', height: '16px' },
  help: { textAlign: 'right', color: 'gray' },
  tooltipPadding: { padding: 0 },
  inputWidth: {width: '100%'}
});
